// Matchmaking UI state (shared, runes). Driven by the server's QueueStatus/MatchFound
// heartbeat; the floating QueueOverlay reads it. A DuelStart (handled in App) ends the
// search by switching to the duel screen, which unmounts the overlay.

import type { DuelFormat, RankMode } from "@ygoevo/world-protocol";

export const mm = $state({
  searching: false,
  mode: null as RankMode | null,
  format: "world" as DuelFormat, // which mode's pool we're in (drives the overlay label)
  waited: 0, // seconds in queue
  pool: 0, // players waiting in this pool
  found: false, // opponent matched, duel about to start
});

export function resetMm(): void {
  mm.searching = false;
  mm.mode = null;
  mm.format = "world";
  mm.waited = 0;
  mm.pool = 0;
  mm.found = false;
}
